import { render } from "./TheError.vue?vue&type=template&id=14680f22&ts=true"
import script from "./TheError.vue?vue&type=script&lang=ts"
export * from "./TheError.vue?vue&type=script&lang=ts"

import "./TheError.vue?vue&type=style&index=0&id=14680f22&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__